module.exports = __webpack_public_path__ + "resources/img/img_blue_prism1_m_en.c197e9b90cdd9f724ca7ee5d0b52c3d0.png";